import videojs from 'video.js'
import BasePlugin from './base-plugin'
import { vjs_El, vjs_find } from './utils'

class ZoomPlugin extends BasePlugin {
  constructor(player, options) {
    super(player)
    this.zoomRate = 1
    this.isDragging = false
    this.movingStart = []

    const mainMenuItemEl = vjs_El('li', 'vjs-settings-item vjs-extend-zoom vjs-menu-forward', 'Zoom<span class="zoom-label">100%</span>')
    mainMenuItemEl.ariaDisabled = 'false'
    mainMenuItemEl.ariaLabel = 'Open zoom container'
    mainMenuItemEl.role = 'menuitem'

    mainMenuItemEl.onclick = mainMenuItemEl.ontouchend = (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      player.trigger('settings:showSubMenu', 'zoomMenu')
    }

    const subMenuEl = vjs_El('div', 'vjs-submenu vjs-zoom-menu vjs-hidden')
    subMenuEl.innerHTML = '<div class="vjs-settings-back vjs-return">Zoom</div>'

    const sliderEl = vjs_El('div', 'vjs-zoom-slider', '<div class="vjs-zoom-back"></div>')
    sliderEl.airaLabel = 'Zoom slider'
    sliderEl.role = 'slider'
    sliderEl.airaLive = 'polite'
    sliderEl.airaValuemin = '0'
    sliderEl.airaValuemax = '500'
    sliderEl.airaValuetext = '0%'
    sliderEl.onclick = (e) => {
      e.stopImmediatePropagation()
    }
    sliderEl.onmousedown = (e) => {
      e.stopImmediatePropagation()
      this.dragZoomLevel(e)
      document.addEventListener('mousemove', this.dragZoomLevel, false)
      document.addEventListener('mouseup', this.dropZoomLevel, false)
    }
    this.sliderEl = sliderEl

    this.zoomLevelEl = vjs_El('div', 'vjs-zoom-level')
    sliderEl.appendChild(this.zoomLevelEl)
    subMenuEl.appendChild(sliderEl)

    const resetZoomEl = vjs_El('div', 'vjs-reset-zoom', 'Reset')
    resetZoomEl.role = 'button'
    resetZoomEl.airaLabel = 'Reset zoom'
    resetZoomEl.airaDisabled = 'false'
    resetZoomEl.onmouseup = () => this.resetZoom()
    subMenuEl.appendChild(resetZoomEl)

    const tech = player.$('.vjs-tech')
    vjs_find(this.playerElement, '.vjs-poster').style.pointerEvents = 'none'
    tech.onmousedown = (e) => {
      if (this.zoomRate > 1) {
        e.preventDefault()
        e.stopPropagation()
        this.isDragging = true
        this.movingStart = [tech.offsetLeft - e.clientX, tech.offsetTop - e.clientY]
        document.addEventListener('mouseup', this.onMouseUp, true)
        document.addEventListener('mousemove', this.onMouseMove, true)
      }
    }

    if (options.zoomInfo) {
      const zoomInfoEl = vjs_El('div', 'vjs-zoom-parent vjs-hidden')
      const resetZoomEl = vjs_El('div', 'vjs-reset-zoom')
      resetZoomEl.innerHTML = '100%'
      zoomInfoEl.appendChild(resetZoomEl)
      const resetCenterEl = vjs_El(
        'div',
        'vjs-reset-center',
        '<span data-id="center" aria-hidden="true" class="vjs-icon-placeholder"></span>',
      )
      const resetCancelEl = vjs_El(
        'div',
        'vjs-reset-cancel',
        '<span data-id="cancel" aria-hidden="true" class="vjs-icon-placeholder"></span>',
      )

      zoomInfoEl.appendChild(resetCenterEl)
      zoomInfoEl.appendChild(resetCancelEl)
      resetCancelEl.onmouseup = () => {
        this.resetZoom()
      }
      resetCenterEl.onmouseup = (e) => {
        this.moveToCenter(e)
      }
      this.playerElement.appendChild(zoomInfoEl)
      this.zoomInfoEl = zoomInfoEl
    }

    player.SettingsMenuPlugin().addMenu('zoomMenu', mainMenuItemEl, subMenuEl)
  }

  onMouseMove = (e) => {
    e.preventDefault()
    if (this.isDragging) {
      let i = e.clientX + this.movingStart[0]
      let t = e.clientY + this.movingStart[1]
      const s = (this.playerElement.offsetWidth / 2) * (this.zoomRate - 1)
      const a = (this.playerElement.offsetHeight / 2) * (this.zoomRate - 1)
      if (i > s)
        i = s
      if (i < -1 * s)
        i = -1 * s
      if (t > a)
        t = a
      if (t < -1 * a)
        t = -1 * a
      const tech = this.player.$('.vjs-tech')
      tech.style.left = `${i}px`
      tech.style.top = `${t}px`
    }
  }

  onMouseUp = (e) => {
    e.stopImmediatePropagation()
    e.preventDefault()
    this.isDragging = false
    document.removeEventListener('mouseup', this.onMouseUp, true)
    document.removeEventListener('mousemove', this.onMouseMove, true)
  }

  dragZoomLevel = (e) => {
    const tech = this.player.$('.vjs-tech')
    tech.style.pointerEvents = 'auto'
    const l = this.sliderEl.offsetHeight
    let r = e.pageY - (this.sliderEl.getBoundingClientRect().top + window.scrollY)
    if (r > l)
      r = l
    if (r < 0)
      r = 0
    let v = Number.parseInt(100 - (r / l) * 100, 10)
    v = Math.max(Math.min(v, 100), 0)
    this.zoomLevelEl.style.height = `${v}%`
    const f = 1 + (4 * v) / 100
    this.zoomRate = f
    this.sliderEl.setAttribute('aria-valuetext', `${Number.parseInt(100 * f)}%`)
    this.applyZoomEffect(tech, f)
    this.updateZoomLabel(100 * f)
    if (f > 1) {
      videojs.options.blockKeys = true
      if (this.zoomInfoEl) {
        this.dom.removeClass(this.zoomInfoEl, this.hiddenClass)
      }
    }
    else {
      this.resetZoom()
      videojs.options.blockKeys = false
      if (this.zoomInfoEl) {
        this.dom.addClass(this.zoomInfoEl, this.hiddenClass)
      }
    }
  }

  dropZoomLevel = () => {
    document.removeEventListener('mouseup', this.dropZoomLevel)
    document.removeEventListener('mousemove', this.dragZoomLevel)
  }

  moveToCenter = (e) => {
    e.preventDefault()
    const t = this.player.$('.vjs-tech')
    t.style.left = `${t.offsetWidth / 2 - this.playerElement.offsetWidth / 2}px`
    t.style.top = `${t.offsetHeight / 2 - this.playerElement.offsetHeight / 2}px`
  }

  resetZoom = () => {
    this.zoomRate = 1
    vjs_find(this.playerElement, '.vjs-zoom-level').style.height = '0'
    const i = this.player.$('.vjs-tech')
    this.applyZoomEffect(i, 1)
    i.style.top = 0
    i.style.left = 0
    this.updateZoomLabel(100)
    if (this.zoomInfoEl) {
      this.dom.addClass(this.zoomInfoEl, this.hiddenClass)
    }
    return false
  }

  updateZoomLabel = (zoomRate) => {
    try {
      vjs_find(this.playerElement, '.vjs-reset-zoom').innerHTML = `${Number.parseInt(zoomRate, 10)}%`
      vjs_find(this.playerElement, '.zoom-label').innerHTML = `${Number.parseInt(zoomRate, 10)}%`
    }
    catch (_err) {
    }
  }

  applyZoomEffect = (e, scaleValue) => {
    e.style.scale = scaleValue
  }
}

export default ZoomPlugin
